import React, { useEffect, useState } from 'react';
import { getdata } from "../../util/global";
import { customer, customerdef, subscription, deliveryitem } from './Datatype';
import CustomerTable from './CustomerTable';
import CustomerForm from './CustomerForm';
import CustomerActivityLog from './CustomerActivityLog';

// Customer container: owns the customer list, the modal mode and the form data,
// and hands them down to CustomerTable (display) and CustomerForm (add/edit).
const Customer = () => {
  const [customers, setcustomers] = useState<customer[]>([]);
  // "" = no modal open, "showcustomerform" = add/edit modal open, "showcustomeractivitylog" = activity log modal open
  const [showmodal, setshowmodal] = useState("");
  const [formdata, setformdata] = useState<customer>(customerdef);
  // text typed in the search box above the table
  const [search, setsearch] = useState("");
  // the picked customer's records, loaded by openactivitylog
  const [subscriptions, setsubscriptions] = useState<subscription[]>([]);
  const [payments, setpayments] = useState<any[]>([]);
  const [deliveries, setdeliveries] = useState<deliveryitem[]>([]);

  // load all customers (appusers with usertype "customer") and show the newest first
  const fetchdata = async () => {
    try {
      const res = await getdata({ filter: { datatype: "appuser", usertype: "customer" } });
      setcustomers(res ? [...res].reverse() : []);
    } catch (err) {
      console.error(err);
    }
  };

  // reset the form to a blank customer and open the modal
  const openadd = () => {
    setformdata({ ...customerdef });
    setshowmodal("showcustomerform");
  };

  // load the picked customer into the form and open the modal
  const openedit = (item: customer) => {
    setformdata({ ...item });
    setshowmodal("showcustomerform");
  };

  // load the picked customer's subscriptions, payments and deliveries and open the activity log modal
  const openactivitylog = async (item: customer) => {
    setformdata({ ...item });
    setsubscriptions(await getdata({ filter: { datatype: "subscriptiondata", _userid: item._id } }));
    setpayments(await getdata({ filter: { datatype: "paymentdata", _userid: item._id } }));
    setdeliveries(await getdata({ filter: { datatype: "deliverydata", _userid: item._id } }));
    setshowmodal("showcustomeractivitylog");
  };

  // initial load on mount
  useEffect(() => {
    fetchdata();
  }, []);

  // only the customers matching the search box, on name, email, phone or customer code
  const shown = customers.filter(c => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return [c.name, c.email, c.phone, c.code].some(v => (v || "").toLowerCase().includes(q));
  });

  return (
    <div className="content-area">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h3>Customers</h3>
        <input
          type="search"
          className="form-input"
          style={{ width: "320px" }}
          placeholder="Search name, email or phone"
          value={search}
          onChange={(e) => setsearch(e.target.value)}
        />
        <button className="btn-blue" onClick={openadd}>+ Add Customer</button>
      </div>

      <CustomerTable
        customers={shown}
        openedit={openedit}
        openactivitylog={openactivitylog}
      />
      <CustomerForm
        showmodal={showmodal}
        setshowmodal={setshowmodal}
        formdata={formdata}
        setformdata={setformdata}
        fetchdata={fetchdata}
      />
      <CustomerActivityLog
        showmodal={showmodal}
        setshowmodal={setshowmodal}
        formdata={formdata}
        subscriptions={subscriptions}
        payments={payments}
        deliveries={deliveries}
      />
    </div>
  );
};

export default Customer;
